import React from 'react';
import {
  Col,
  Form,
  Input,
  Row,
  Typography,
  Checkbox,
  TimePicker,
  Space,
} from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'components';

const format = 'HH:mm';

const CheckboxesSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('FASCE ORARIE')}</Typography.Title>
      </Col>
      <Form.List name='times'>
        {(fields, { add, remove, ...rest }) => (
          <Row>
            {fields.map(({ key, name, ...restField }) => {
              return (
                <Col span={24}>
                  <Space
                    key={key}
                    style={{ display: 'flex', marginBottom: 8 }}
                    align='center'
                  >
                    <Form.Item
                      {...restField}
                      label={t('Dal al')}
                      name={[name, 'time_from']}
                    >
                      <TimePicker format={format} />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      label={t('Dal al')}
                      name={[name, 'time_to']}
                    >
                      <TimePicker format={format} />
                    </Form.Item>
                    {key > 0 && (
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    )}
                  </Space>
                </Col>
              );
            })}
            <Form.Item>
              <Button onClick={() => add()} icon={<PlusOutlined />}>
                Add field
              </Button>
            </Form.Item>
          </Row>
        )}
      </Form.List>
    </Row>
  );
};

export default React.memo(CheckboxesSection);
